import { Page } from '@/core/architecture'

import { UserOwnedItemsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * UserOwnedItems Page
 * Implemented as a practical sample.
 */
export const UserOwnedItems: Page = () => {
  const { state, actions } = useViewModel()

  return (
    <UserOwnedItemsTemplate
      state={state}
      onFetchMore={actions.onFetchMore}
      onFilter={actions.onFilter}
    />
  )
}
